import request from "@/utils/request";

// 获取储能站列表
export const pageParkList = (params) => {
  return request({
    url: "/api/hzn-sli/park/pageParkList",
    method: "get",
    params,
  });
};

// 园区总览
export const getParkInfo = (params) => {
  return request({
    url: "/api/hzn-home/home-page/V2/park-Info",
    method: "get",
    params: params,
  });
};

// 虚拟电站总览
export const virtualStationInfo = (params) => {
  return request({
    url: "/api/hzn-home/home-page/V2/virtual-Station-Info",
    method: "get",
    params: params,
  });
};

// 虚拟电厂状态
export const virtualStation = () => {
  return request({
    url: "/api/hzn-home/sli/virtualStation",
    method: "get",
  });
};

// 园区接入->虚拟电厂->光伏曲线
export const lineEchart = () => {
  return request({
    url: "/api/hzn-home/sli/lineEchart",
    method: "get",
  });
};

// 源网荷储一体化管控平台1:发电设备2:负荷设备3:储能设备
export const circulateData = (params) => {
  return request({
    url: "/api/hzn-home/home-page/V2/circulateData",
    method: "get",
    params,
  });
};

// 大屏能量流
export const energyFlow = (params) => {
  return request({
    url: "/api/hzn-home/home-page/V2/energyFlow",
    method: "get",
    params,
  });
};

// 左屏下方图片
export const parkCarousel = (params) => {
  return request({
    url: "/api/hzn-home/home-page/V2/parkCarousel",
    method: "get",
    params,
  });
};
